import { render, staticRenderFns } from "./LpsList.vue?vue&type=template&id=30b6eb53&scoped=true"
import script from "./LpsList.vue?vue&type=script&lang=js"
export * from "./LpsList.vue?vue&type=script&lang=js"
import style0 from "./LpsList.vue?vue&type=style&index=0&id=30b6eb53&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30b6eb53",
  null
  
)

export default component.exports